import { Component, OnInit } from '@angular/core';

import { OfficeSecurityService } from '@core/core.module';
import { NavigationFacade } from '../../store/navigation.facade';

@Component({
    selector: 'app-default-route',
    templateUrl: './default-route.component.html',
    styleUrls: ['./default-route.component.scss'],
    standalone: false
})
export class DefaultRouteComponent implements OnInit {
    constructor(private navigationFacade: NavigationFacade, private privilegesService: OfficeSecurityService) { }

    ngOnInit(): void {
        if (this.privilegesService.canUseCourtBookingSnapshot) {
            this.navigationFacade.navigate('court-sheet');
        } else {
            this.navigationFacade.navigate('forbidden', null, false);
        }
    }
}
